import { ErrorResponse, SuccessfulResponse } from "@/api/fetcher_v2";
import { groupSearches } from "@/lib/alert";
import { Search, SearchLight } from "@/types/Search";
import { useMemo } from "react";

export function useGroupedSearches<T extends Search | SearchLight>(
  searches: ErrorResponse<unknown> | SuccessfulResponse<T[]> | undefined
) {
  return useMemo(() => {
    if (searches?.ok) {
      const { active, inactive, saved } = groupSearches(searches.data);

      return {
        activeSearches: active,
        savedSearches: saved,
        inactiveSearches: inactive,
        hasSearches:
          active.length > 0 || saved.length > 0 || inactive.length > 0,
      };
    }

    return {
      activeSearches: [],
      savedSearches: [],
      inactiveSearches: [],
      hasSearches: false,
    };
  }, [searches]);
}
